import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './NavLink.scss';

interface NavLinkProps {
  label: string;
  to: string;
  selected?: boolean;
  style?: Object;
}

function NavLink({ label, to, selected = false, style = {} }: NavLinkProps) {
  const location = useLocation();
  const isCurrentPath = location.pathname === to || selected;
  return (
    <Link
      style={style}
      className={`navLink ${
        isCurrentPath ? 'selectedNavLink' : 'unSelectedNavLink'
      }`}
      to={to}
    >
      {label}
    </Link>
  );
}

export default NavLink;
